import React from 'react';
import { Layout, Space } from 'antd';
import { Typography } from 'antd';
import styles from './index.scss';
import { useSiteConfig } from '@/contexts/SiteConfigProvider';

const { Link: AntLink } = Typography;

const { Footer: AntFooter } = Layout;

const Footer: React.FC = () => {
  const { VERSION, COMPANY } = useSiteConfig();

  return (
    <AntFooter className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.left}>
          <AntLink target="/privacy">隐私政策</AntLink>
          <span className={styles.divider}>|</span>
          <AntLink target="/terms">服务条款</AntLink>
        </div>

        <div className={styles.center}>
          <Space split={<span className={styles.divider}>|</span>}>
            <span>
              Copyright © {new Date().getFullYear()} {COMPANY?.name}
            </span>
            <AntLink href={COMPANY?.icpLink} target="_blank">
              {COMPANY?.icp}
            </AntLink>
            {/* <Text>{COMPANY?.address}</Text> */}
          </Space>
        </div>

        <div className={styles.right}>
          <span className={styles.version}>
            {VERSION?.version}({VERSION?.details?.hash})
          </span>
        </div>
      </div>
    </AntFooter>
  );
};

export default Footer;
